import suppliers from './../../supplier/suppliers';
import travellerTypes from './../traveller-types';

export default function TravellerService(
    tripUtils,
    tripOptionsService,
    tripAPI,
    userService,
    flightsService,
    tripDetailsService
) {
    'ngInject';

    return {
        getTravellerFullName: function(traveller, titlePeriod) {
            let fullName = '';
            if (traveller) {
                fullName = _.compact([
                    composeTravellerTitle(traveller.Title, titlePeriod),
                    traveller.FirstName,
                    traveller.MiddleName,
                    traveller.LastName,
                ]).join(' ');
            }
            return fullName.trim();
        },
        addTravellerFullNameField: function(traveller) {
            if (traveller._fullName) {
                return;
            }
            Object.defineProperty(traveller, '_fullName', {
                get: () => {
                    return this.getTravellerFullName(traveller);
                },
                set: function() {
                },
            });
        },
        addInfantCombinedNameField: function(infant, adults) {
            const travellerUtils = this; //eslint-disable-line
            Object.defineProperty(infant, '_combinedName', {
                get: () => {
                    const infantFullName = travellerUtils.getTravellerFullName(infant);
                    const adultTraveller = travellerUtils.getTravellerById(adults, angular.isNumber(infant.AdultTripPassengerId) ? infant.AdultTripPassengerId : infant.AdultTripPassengerId.value);
                    const adultFullName = travellerUtils.getTravellerFullName(adultTraveller);
                    return (adultFullName + infantFullName);
                },
                set: function() {},
            });
        },
        addInfantIsAdultUsed: function(infant, infants) {
            Object.defineProperty(infant, '_isAdultUsed', {
                get: function() {
                    let isUsed = false;
                    const adultId = _.isUndefined(this.AdultTripPassengerId.value)
                            ? this.AdultTripPassengerId
                            : this.AdultTripPassengerId.value;

                    angular.forEach(infants, function(inf) {
                        const infantAdultId = _.isUndefined(inf.AdultTripPassengerId.value)
                            ? inf.AdultTripPassengerId
                            : inf.AdultTripPassengerId.value;
                        if (this.Id !== inf.Id && inf.IsCompleted && infantAdultId === adultId) {
                            isUsed = true;
                        }
                    }.bind(this));

                    return isUsed;
                },
                set: function() {},
            });
        },
        addAdultCombinedNameField: function(adult, infants) {
            const travellerUtils = this;//eslint-disable-line
            if (adult._combinedName) {
               return;
            }
            Object.defineProperty(adult, '_combinedName', {
                get: () => {
                    const adultFullName = travellerUtils.getTravellerFullName(adult);
                    const infantTraveller = _.find(infants, function(infant) {
                        return infant.AdultTripPassengerId === adult.Id
                            || infant.AdultTripPassengerId.value === adult.Id;
                    });
                    const infantFullName = travellerUtils.getTravellerFullName(infantTraveller);
                    return (adultFullName + infantFullName);
                },
                set: function() {},
            });
        },
        parseTravellerFieldDate: function(date) {
            const regionalSettings = userService && userService.getRegionalSettings();
            return (date) ? moment(date).format(regionalSettings.dateFormat) : null;
        },
        addTravellerAdditionalFields: function(traveller, travellerGroups) {
            this.addTravellerFullNameField(traveller);
            if (isAdult(traveller.PassengerType)) {
                this.addAdultCombinedNameField(traveller, travellerGroups.Infant);
            }
            if (isInfant(traveller.PassengerType)) {
                this.addInfantCombinedNameField(traveller, travellerGroups.Adult);
                this.addInfantIsAdultUsed(traveller, travellerGroups.Infant);
            }
        },
        processTraveller: function(traveller, travellerGroups, positionIndex) {
            const travellerTitles = isAdult(traveller.PassengerType)
                ? tripOptionsService.adultTravellerTitles
                : tripOptionsService.childTravellerTitles;

            traveller.positionIndex = positionIndex;

            if (!traveller.TravellerFlightDetails) {
                traveller.TravellerFlightDetails = defaultFlightFields();
            }

            traveller.Title
                = _.clone(this.getTravellerTitle(traveller.Title, travellerTitles));
            traveller.TelephoneNumberCallingCode
                = _.clone(this.getTravellerCallingCode(traveller.TelephoneNumberCallingCode));
            traveller.TravellerFlightDetails.Gender
                = _.clone(this.getTravellerGender(traveller.TravellerFlightDetails.Gender));
            traveller.TravellerFlightDetails.NationalityCode
                = _.clone(this.getTravellerNationalityCode(traveller.TravellerFlightDetails.NationalityCode));
            traveller.TravellerFlightDetails.PassportIssuingCountryCode
                = _.clone(this.getTravellerNationalityCode(traveller.TravellerFlightDetails.PassportIssuingCountryCode));

            traveller.TravellerFlightDetails.DateOfBirth
                = this.parseTravellerFieldDate(traveller.TravellerFlightDetails.DateOfBirth);
            traveller.TravellerFlightDetails.PassportExpiryDate
                = this.parseTravellerFieldDate(traveller.TravellerFlightDetails.PassportExpiryDate);

            this.addTravellerAdditionalFields(traveller, travellerGroups);
            return traveller;
        },
        processTravellers: function(travellers) {
            const groupedTravellers = _.groupBy(travellers, 'PassengerType');
            const groupSort = (traveller) => !traveller.IsCompleted;
            const travellerGroups = {
                Adult: _.sortBy(groupedTravellers.Adult, groupSort),
                Child: _.sortBy(groupedTravellers.Child, groupSort),
                Infant: _.sortBy(groupedTravellers.Infant, groupSort),
            };

            _.each(travellerGroups.Adult, (adult) => {
                const positionIndex = adult.OrderIndex || getTravellerPlace(travellerGroups.Adult, adult, 0);
                this.processTraveller(adult, travellerGroups, positionIndex);
            });

            _.each(travellerGroups.Child, (child) => {
                const positionIndex = child.OrderIndex || getTravellerPlace(travellerGroups.Child, child, travellerGroups.Adult.length);
                this.processTraveller(child, travellerGroups, positionIndex);
            });

            const infantShift = travellerGroups.Adult.length + travellerGroups.Child.length;
            _.each(travellerGroups.Infant, (infant) => {
                const positionIndex = infant.OrderIndex || getTravellerPlace(travellerGroups.Infant, infant, infantShift);
                this.processTraveller(infant, travellerGroups, positionIndex);
            });
            return travellerGroups;
        },
        getTravellerById: function(travellers, id) {
            return _.find(travellers, function(traveller) {
                return (traveller.Id === id || traveller.TripPassengerId === id);
            });
        },
        getTravellerTitle: function(title, travellerTitles) {
            if (!title) {
                return travellerTitles[0];
            }
            return _.find(travellerTitles, function(travellerTitle) {
                    return (travellerTitle.text === title);
                }) || title;
        },
        getTravellerGender: function(travellerGender) {
            const genderList = tripOptionsService.getGenders();
            const selectedGender = genderList.find((gender) => gender.value === travellerGender);
            return selectedGender ? selectedGender : genderList[0];
        },
        getTravellerCallingCode: function(travellerCallingCode) {
            if (!travellerCallingCode) {
                return tripOptionsService.getCallingCodes()[0];
            }
            return _.find(tripOptionsService.getCallingCodes(), function(code) {
                return (+code.value === +travellerCallingCode);
            });
        },
        getTravellerNationalityCode: function(travellerNationalityCode) {
            return _.find(tripOptionsService.getCountries(), function(country) {
                return (country.value === travellerNationalityCode);
            });
        },
        findTravellerNameDuplication: function(travellerData, travellersList) {
            let isDuplicated = false;
            const TripPassengerId = travellerData.TripPassengerId || travellerData.Id;
            const adultPassengerId = travellerData.AdultTripPassengerId && travellerData.AdultTripPassengerId.value;
            const travellerNameObject = {
                LastName: _.trim(travellerData.LastName).toLowerCase(),
                FirstName: _.trim(travellerData.FirstName).toLowerCase(),
            };

            _.forEach(travellersList, function(travellerType) {
                _.forEach(travellerType, function(traveller) {
                    const checkTraveller = angular.copy(traveller);
                    const checkTravellerId = checkTraveller.TripPassengerId || checkTraveller.Id;

                    if (TripPassengerId && (TripPassengerId === checkTravellerId)) {
                        return;
                    }

                    if (adultPassengerId && (adultPassengerId === checkTravellerId)) {
                        return;
                    }

                    checkTraveller.FirstName = (checkTraveller.FirstName)
                        ? checkTraveller.FirstName.toLowerCase()
                        : null;
                    checkTraveller.LastName = (checkTraveller.LastName)
                        ? checkTraveller.LastName.toLowerCase()
                        : null;

                    isDuplicated = isDuplicated || _.findWhere([checkTraveller], travellerNameObject);
                });
            });

            return isDuplicated;
        },
        getProcessedClubCards: function(clubCards) {
            return (clubCards || []).map(({SupplierCode, Ffn, Id}) => ({Supplier: SupplierCode, Number: Ffn, Id}));
        },
        saveTraveller: function(travellerData, tripId, isFlightDataRequired, isRailDataRequired, orderIndex) {
            const travellerRequestData = {
                TripId: tripId,
                PassengerType: travellerData.PassengerType,
                FirstName: travellerData.FirstName,
                MiddleName: travellerData.MiddleName,
                LastName: travellerData.LastName,
                ClubCards: this.getProcessedClubCards(travellerData.ClubCards),
                OrderIndex: orderIndex,
            };

            if (isInfant(travellerData.PassengerType)) {
                travellerRequestData.AdultTripPassengerId = travellerData.AdultTripPassengerId.value;
            } else {
                travellerRequestData.Title = travellerData.Title.text;
                travellerRequestData.EmailAddress = travellerData.EmailAddress;
                travellerRequestData.TelephoneNumberCallingCode
                    = travellerData.TelephoneNumberCallingCode.value;
                travellerRequestData.TelephoneNumber = travellerData.TelephoneNumber;
            }

            const {TripPassengerId} = travellerData;
            travellerRequestData.TripPassengerId = TripPassengerId !== 0 ? TripPassengerId : undefined;
            travellerRequestData.TravellerProfileId = travellerData.TravellerProfileId || undefined;

            const isGenderSelected = travellerData.TravellerFlightDetails
                && travellerData.TravellerFlightDetails.Gender
                && travellerData.TravellerFlightDetails.Gender.value;

            if (isGenderSelected) {
                travellerRequestData.Gender = travellerData.TravellerFlightDetails.Gender.value;
            }

            const {PassportIssuingCountryCode, NationalityCode} = travellerData.TravellerFlightDetails;

            if (isFlightDataRequired) {
                travellerRequestData.TravellerFlightDetails = {
                    KnownTravellerNumber: travellerData.TravellerFlightDetails.KnownTravellerNumber,
                    RedressNumber: travellerData.TravellerFlightDetails.RedressNumber,
                    Gender: travellerData.TravellerFlightDetails.Gender.value,
                    DateOfBirth: getFormattedDate(travellerData.TravellerFlightDetails.DateOfBirth),
                    PassportNumber: travellerData.TravellerFlightDetails.PassportNumber,
                    PassportExpiryDate: getFormattedDate(travellerData.TravellerFlightDetails.PassportExpiryDate),
                    PassportIssuingCountryCode: PassportIssuingCountryCode && PassportIssuingCountryCode.value,
                    NationalityCode: NationalityCode && NationalityCode.value,
                };
            }

            if (isRailDataRequired && !isFlightDataRequired) {
                travellerRequestData.TravellerFlightDetails = {
                    Gender: travellerData.TravellerFlightDetails.Gender.value,
                    DateOfBirth: getFormattedDate(travellerData.TravellerFlightDetails.DateOfBirth),
                };
            }

            return tripAPI.saveTraveller(travellerRequestData);
        },
        getAllocationAdults: function(adults) {
            return _.map(adults, (adult) => {
                return {
                    name: this.getTravellerFullName(adult),
                    id: adult.Id || adult.TripPassengerId,
                };
            });
        },
        processTitles,
        isGenderRequiredForAnyFlight,
        isGenderRequiredForAnyHotel,
        assignInfantNamesToAdults,
        isEditIconEnabled,
        getTravellerPlace,
    };

    function getFormattedDate(date) {
        const regionalSettings = userService && userService.getRegionalSettings();
        if (date === null) {
            return date;
        }
        return _.isDate(date)
            ? moment(date)
                .utcOffset(0, true)
                .format()
            : moment(date, regionalSettings.dateFormat)
                .utcOffset(0, true)
                .format();

    }
    function defaultFlightFields() {
        return {
            KnownTravellerNumber: null,
            RedressNumber: null,
            Gender: null,
            DateOfBirth: null,
            PassportNumber: null,
            PassportExpiryDate: null,
            PassportIssuingCountryCode: null,
            NationalityCode: null,
        };

    }
    function composeTravellerTitle(title, titlePeriod) {
        if (_.isObject(title)) {
            return (title.value) ? title.text + (titlePeriod ? '.' : '') : '';
        } else if (_.isString(title)) {
            return title + (titlePeriod ? '.' : '');
        }
    }

    function isEditIconEnabled(locked, disable, canceled, tripDetails) {
        return !(tripDetails
            && !!tripDetails.IsOfflineTrip
            || locked
            || disable
            || canceled);
    }

    function isGenderRequiredForAnyFlight(tripDetails, editedAdult) {
        return isEnhancedTitle(editedAdult)
            && tripDetails
            && tripDetails.Flights
            && tripDetails.Flights.length
            && tripDetails.Flights.some(flightsService.isLowCostAirline);

    }
    function isGenderRequiredForAnyHotel(tripDetails, editedAdult) {
        return isEnhancedTitle(editedAdult)
            && tripContainsHotelWithSupplier(tripDetails, suppliers.travelfusion.id);

    }
    function tripContainsHotelWithSupplier(tripDetails, supplierId) {
        return tripDetails
            && tripDetails.Hotels
            && tripDetails.Hotels.length
            && tripDetails.Hotels.some(({Supplier}) => Supplier === supplierId);

    }
    function isEnhancedTitle(editedAdult) {
        const GENDER_BOTH = 0;
        return editedAdult.Title
            && !editedAdult.Title.isSupportedByLowCostAirlines
            && editedAdult.Title.gender === GENDER_BOTH;

    }
    function processTitles(titles, tripDetails) {

        const excludeNotSupportedTitles = flightsService.isLowCostAirline()
            || tripContainsHotelWithSupplier(tripDetails, suppliers.travelfusion.id)
            || tripDetailsService.doesTripContainTrainlineTrain(tripDetails);
        if (excludeNotSupportedTitles) {
            return titles.filter(({isSupportedByTrainline}) => isSupportedByTrainline);

        }
        return titles;

    }
    function isAdult(travellerType) {
        return travellerType === travellerTypes.ADULT;

    }
    function isInfant(travellerType) {
        return travellerType === travellerTypes.INFANT;

    }

    function assignInfantNamesToAdults(travellers) {
        const {Infant, Adult} = travellers;
        Infant.forEach((infant) => {
            const searchedAdult = Adult.find((adult) => adult.Id === infant.AdultTripPassengerId);
            if (searchedAdult) {
                searchedAdult.infantFullName = `${infant.FirstName} ${infant.LastName}`;
            }
        });
        return travellers;
    }

    function getTravellerPlace(travellers, adult, shift) {
        const orderNumber = travellers.indexOf(adult);
        return orderNumber !== -1 ? orderNumber + 1 + shift : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/traveller-utils-service.js